import getDisplayDateParserConfig from './getDisplayDateParserConfig';
import type { OwaDate } from '../schema';
import { getDisplayDateParserRegExp } from './getDisplayDateParserRegExp';
import { parseDisplayDate } from './parseDisplayDate';
import { getTimeFormat } from 'owa-datetime-store';

/**
 * Parse a display date based on the user's selected time format.
 */
export default function parseUserDate(value: string, referenceDate?: OwaDate): OwaDate {
    const config = getDisplayDateParserConfig();
    const regexp = getDisplayDateParserRegExp(getTimeFormat());
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (16,5): Type 'OwaDate | null' is not assignable to type 'OwaDate'.
    // @ts-expect-error
    return parseDisplayDate(value, regexp, config, referenceDate);
}
